import script from "./NoticeSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeSingle.vue?vue&type=script&setup=true&lang=js"

import "./NoticeSingle.vue?vue&type=style&index=0&id=4b7c9672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b7c9672"]])

export default __exports__